import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { io, Socket } from "socket.io-client";
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket!: Socket;
  private isConnected$ = new BehaviorSubject<boolean>(false);
  id!: number|null ;
  name!: string | null;
 private token: string = localStorage.getItem('token') ?? ''
 private documentStatusSubject = new BehaviorSubject<any>(null);
  connect(token:string): void {
    this.id = Number(localStorage.getItem('user_id'));
    this.name = localStorage.getItem('username');
    if(this.id && this.name && this.token){
      let socketPath = '/socket.io';
      try {
        const url = new URL(environment.mainApi);
        if (url.pathname && url.pathname !== '/') {
          socketPath = url.pathname + (url.pathname.endsWith('/') ? 'socket.io' : '/socket.io');
        }
      } catch(e) {
        // Fallback if URL parsing fails
      }
      
      this.socket = io(environment.mainApi, {
        path: socketPath,
        auth: { token }
      });

    this.setupListeners();
  }
}
  
setupListeners(): void {
  this.socket.on('connect', () => {
    console.log('Connected to Socket.IO server');
    this.subscribeUser();
  });

  this.socket.on('subscribed', (msg:any) => {
    console.log("subscribed event:: ", msg);
  });
  this.socket.on('document_status', (data:any) => {
    // console.log("document_status event:: ", data);
    this.documentStatusSubject.next(data);  // Emit the event to subscribers
  })

  this.socket.on('disconnect', (err:any) => {
    // this.connect(this.token)
  });

  this.socket.on('connect_error', (err:any) => {
    console.error('Connection failed:', err.message);
  });
}
subscribeUser(): void {
  this.socket.emit('user_subscribe', {
    "id": this.id,
    "name": this.name,
    // "document_status":"test"
  });
}

  
 

  onDocumentStatus(): Observable<any> {
    return this.documentStatusSubject.asObservable();
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log('WebSocket connection closed');
    }
  }
}
